import React from 'react'

export const castRef = <T extends HTMLElement>(
  ref: React.RefObject<T | null>,
): React.RefObject<T> => {
  return ref as React.RefObject<T>
}

export const hasNoValueOrIsWhitespace = (value?: string) => {
  return value === undefined || value === null || value === ''
}

export const hasValue = (value?: string | unknown | number) => {
  if (typeof value === 'number') {
    return value !== undefined && value !== null
  }

  if (typeof value === 'object') {
    return value !== undefined && value !== null
  }

  return !hasNoValueOrIsWhitespace(value as string | undefined)
}

export const isNumeric = (value: string) => {
  const num = Number.parseFloat(value)
  const isNan = isNaN(num)
  return !isNan
}

export const allHaveValue = (
  values: (string | number | unknown | undefined)[],
) => {
  return values.every(hasValue)
}

export const someHaveValue = (
  values: (string | number | unknown | undefined)[],
) => {
  return values.some(hasValue)
}

export const noneHaveValue = (
  values: (string | number | unknown | undefined)[],
) => {
  return !someHaveValue(values)
}

export const isBetween = (x: number, min: number, max: number) => {
  return x > min && x < max
}

export const isInRange = (x: number, min: number, max: number) => {
  return x >= min && x <= max
}

export const clamp = (x: number, min: number, max: number) => {
  return Math.min(Math.max(x, min), max)
}

export const tryGetLocaleNumericString = (value?: number, length = 2) => {
  if (!hasValue(value)) {
    return undefined
  }

  return value?.toLocaleString('en-US', {
    minimumIntegerDigits: length,
    useGrouping: false,
  })
}
